import Network from 'PREPAREsrc/service/Network';
import API from 'PREPAREsrc/service/api';

import { selectUser } from 'slices/commonSelectors';

import {
  ADD_WORKSPACE_TO_WORKSPACE_LIST,
  CHANGE_SELECTED_WORKSPACE,
  CHANGE_WORKSPACE_TIMEZONE,
  UPDATE_ALL_WORKSPACE_LIST,
  CHANGE_SELECTED_WORKSPACE_STATUS,
} from './workspaces.constants';

import { ThunkAction } from '@reduxjs/toolkit';

export const changeSelectedWorkSpace = (
  proposedId: string | undefined
): ThunkAction<any, any, any, any> => {
  return (dispatch) => {
    dispatch({
      type: CHANGE_SELECTED_WORKSPACE,
      payload: proposedId,
    });
  };
};

export const persistUserCurrentExerciseWorkSpace = (
  workspaceId: string | undefined
): ThunkAction<any, any, any, any> => {
  return (_, getState) => {
    const { epic_user_id } = selectUser(getState());

    return Network.post(API.updateUserCurrentExerciseWorkspace, {
      workspaceId,
      userId: epic_user_id,
    }).catch((error) => {
      // TODO: Toast?
      console.error(error);
    });
  };
};

export const changeSelectedWorkSpaceStatus = (
  status: string
): ThunkAction<any, any, any, any> => {
  return (dispatch) => {
    dispatch({
      type: CHANGE_SELECTED_WORKSPACE_STATUS,
      payload: status,
    });
  };
};

export const updateWorkSpaceTimeZone = (
  timezone: string,
  timezoneOffset: string
): ThunkAction<any, any, any, any> => {
  return (dispatch) => {
    dispatch({
      type: CHANGE_WORKSPACE_TIMEZONE,
      payload: { timezone, timezoneOffset },
    });
  };
};

export const updateAllWorkSpaceList = (
  workspaceList: ExerciseWorkspace[]
): ThunkAction<any, any, any, any> => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ALL_WORKSPACE_LIST,
      payload: workspaceList,
    });
  };
};

export const updateWorkSpaceListById = (
  workspace: ExerciseWorkspace
): ThunkAction<any, any, any, any> => {
  return (dispatch) => {
    dispatch({
      type: ADD_WORKSPACE_TO_WORKSPACE_LIST,
      payload: workspace,
    });
  };
};
